import classes from '../../common/styles/FormStyles.module.scss';
import SignInForm from '../../components/auth/SignInForm';
import { notification } from 'antd';
import { spacing } from '../../theming';
import logo from '../../assets/car.png';
import { useTranslation } from 'react-i18next';
import { useMedia } from './../../hooks/useMediaQuery';

function Auth() {
    const [api, contextHolder] = notification.useNotification();

    const openNotification = ({ type = 'error', message = '', description = '', placement = 'top' }) => {
        api[type]({
            message: message,
            description: description,
            placement: placement,
        });
    };
    const { t } = useTranslation(['auth', 'form', 'apiResponses']);
    const { isSmallDevice } = useMedia();

    return (
        <div
            className={classes['auth-wrapper']}
            style={{
                gap: 0,
            }}
        >
            {contextHolder}
            <img src={logo} alt="InterCode_logo" className={classes.logo} />
            <h3
                style={{
                    marginBottom: spacing[2],
                    fontSize: isSmallDevice && 26,
                }}
            >
                {t('auth:login-title')}
            </h3>

            <SignInForm
                openNotification={openNotification}
                t={t}
            />

            <div className={classes.content} style={{ gap: isSmallDevice && 0 }}></div>
        </div>
    );
}

export default Auth;
